import React, { useEffect, useState } from 'react';
import { HiPlus } from "react-icons/hi";
import { HighlightedText } from '../../../../utils/highlightUtils';
import { replaceZIndexStyle } from "../../utils";

interface SuggestedTaskProps {
  task: any;
  boxWidth: number;
  boxheight: number;
  searchText: string;
  group: any;
  index: number;
  dateValidate: number;
  isHoliday: any[];
  onAssignSuggestedTaskClick: (tasksData: any, group: any) => void;
  onSuggestions: (more_tasks: any[], group: any) => void;
}

const SuggestedTask: React.FC<SuggestedTaskProps> = ({
  task,
  boxWidth,
  boxheight,
  searchText,
  group,
  index,
  dateValidate,
  isHoliday,
  onAssignSuggestedTaskClick,
  onSuggestions
}) => {
  // Hover state and z-index coordination (same pattern as TaskBar)
  const [isHovered, setIsHovered] = useState(false);

  const getElements = () => {
    const container = document.getElementById('box-container');
    const rightPane = document.getElementById('right-pane');
    const leftPanel = document.getElementById('left-panel');
    const resourcesText = document.getElementById('resources-text');
    return { container, rightPane, leftPanel, resourcesText };
  };

  const updateZIndices = (zRightPane: number, zLeftPanel: number, zResourcesText: number) => {
    const { rightPane, leftPanel, resourcesText } = getElements();
    if (!rightPane || !leftPanel || !resourcesText) return;

    replaceZIndexStyle(rightPane, zRightPane);
    replaceZIndexStyle(leftPanel, zLeftPanel);
    replaceZIndexStyle(resourcesText, zResourcesText);
  };

  useEffect(() => {
    const { container } = getElements();
    if (!container) return;

    const handleScroll = () => {
      if (isHovered && container.scrollLeft === 0) {
        setIsHovered(false);
        updateZIndices(15, 20, 30);
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [isHovered]);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setIsHovered(true);

    const { container } = getElements();
    if (!container) return;

    const target = event.target as HTMLElement;
    if (target.closest('#group-0') === null || container.scrollTop !== 0) return;

    updateZIndices(9995, 9996, 9997);
  };

  const handleMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
    setIsHovered(false);

    const { container } = getElements();
    if (!container) return;

    const target = event.target as HTMLElement;
    if (target.closest('#group-0') === null || container.scrollTop !== 0) return;

    updateZIndices(15, 20, 30);
  };

  return (
    <>
      {/* Absolute wrapper aligned to the grid cell start */}
      <div
        className={`
          absolute group 
          ${dateValidate === 0 ? "border-green-500 !border-l-2" : "border-gray-500 border-l-[0.5px]"} 
          ${isHoliday.length && "!border-r-2 !border-r-orange-500"}
        `}
        style={{
          left: (index * boxWidth),
          top: 0,
          height: `${boxheight}px`,
          zIndex: isHovered ? 95 : 60,
          pointerEvents: 'auto'
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          id={task.item_id || task.id}
          className="flex border-0 flex-1 z-2 p-[5px] relative flex-wrap bg-[#014737]/50 rounded-lg !border-2 !border-dashed border-zinc-200 cursor-pointer"
          title={task.task_title}
          style={{
            display: "flex",
            flex: 1,
            zIndex: isHovered ? 40 : 15,
            padding: 5,
            position: "relative" as const,
            width: `${boxWidth * Number(task.duration)}px`,
            maxHeight: `${boxheight}px`,
            height: `${boxheight}px`,
            transform: isHovered ? 'translateY(-1px) scale(1.003)' : 'translateY(0)',
            transition: 'all 0.2s ease-in-out',
            boxSizing: 'border-box'
          }}
        >
          <div title={`${task.task_title} (Work Item #${task.item_id})`}
            className="whitespace-nowrap text-ellipsis overflow-hidden w-full">
            <span className="text-white text-sm font-semibold font-['Inter'] leading-[21px]">
              <HighlightedText
                text={task.project_name}
                searchTerm={searchText}
              />:{" "}
            </span>
            <span className="text-white text-sm font-normal font-['Inter'] leading-[21px]">
              <HighlightedText
                text={task.task_title}
                searchTerm={searchText}
              /> (Work Item #{
                searchText && task.item_id.toString().includes(searchText.toLowerCase())
                  ? <HighlightedText
                    text={task.item_id.toString()}
                    searchTerm={searchText}
                  />
                  : task.item_id
              }){" "}
            </span>
          </div>
          <div
            className=" text-[#d5d5dc] text-xs font-medium font-['Inter'] leading-[18px]">{task.duration} days {" ."}</div>
          {task?.more_tasks?.length ? <div
            className="hover:text-[#76a9fa] text-blue-700 text-xs font-medium font-['Inter'] leading-[18px] ml-1 cursor-pointer"
            onClick={e => onSuggestions(task?.more_tasks, group)}
          >
            View More
          </div> : ""}
          <div
            className=" group-hover:block hidden absolute bg-blue-700 p-1 right-[-2px] top-[-12px] cursor-pointer rounded-full"
            onClick={() => onAssignSuggestedTaskClick(task, group)}>
            <HiPlus className=" text-sm text-white  border-0" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SuggestedTask; 